// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"5b2be9f0","280":"8b7a01fa","340":"543dcd5f","404":"d9fe6fe5","432":"b5c98f7f","702":"d630f281","757":"a5524473","816":"dd47eb57","923":"96f5c748"}[chunkId] + ".chunk.js";
};